<template>
  <MilesNBonusRibbon v-if="showRibbon" step="1" />

  <section class="s-strip s-strip--short s-strip--theme-grey">
    <div class="s-strip__header mb-40">
      <div class="page-container">
        <div class="b-strip-header align-items-center">
          <div class="title h2">{{ title }}</div>
        </div>
      </div>
    </div>

    <div class="page-container d-none d-lg-block">
      <BookingWizard :step="step" />
      <BookingPickNReturn />
    </div>

    <div class="page-container d-block d-lg-none">
      <BookingWizard :step="step" />
      <Accordion :title="dictionary.accordionHeaderBookingDetails">
        <BookingPickNReturn />
      </Accordion>
    </div>
  </section>

  <section class="s-strip s-strip--short">
    <div class="page-container">
      <BookingFleet />
    </div>
  </section>

  <BookingSessionTimeoutModal />
</template>

<script>
import BookingWizard from '../components/BookingWizard.vue'
import BookingPickNReturn from '../components/BookingPickNReturn.vue'
import BookingFleet from '../components/BookingFleet.vue'
import Accordion from './../components/common/Accordion.vue'
import BookingSessionTimeoutModal from './../components/BookingSessionTimeoutModal.vue'
import * as lib from './../../lib/lib'
import MBRibbon from '../../modules/MBRibbon'
import MilesNBonusRibbon from '../components/MilesNBonusRibbon.vue'

export default {
  components: {
    BookingWizard,
    BookingPickNReturn,
    BookingFleet,
    Accordion,
    BookingSessionTimeoutModal,
    MilesNBonusRibbon,
  },
  data() {
    return {
      title: null,
      step: 1,

      mbDictionary: {},
      milesNBonusLogo: null,
      showMilesNBonus: lib.getData('milesNBonusData'),
      destinationAllowed: true,
      milesNBonusLoggedIn: false,
      redeemAllowed: false,
      id: '',
      lang: 'en',
    }
  },

  computed: {
    showRibbon() {
      if (!this.destinationAllowed) {
        return false
      }
      if (this.milesNBonusLoggedIn) {
        return this.showMilesNBonus && this.redeemAllowed
      }
      return this.showMilesNBonus
    },
  },

  mounted() {
    const { title } = lib.getData('bookingData')
    this.title = title

    this.lang = lib.getLocaleFromLangAttr()
    if (lib.getData('milesNBonusData')) {
      const { dictionary, configuration, milesNBonusLogo, milesNBonusAccount } =
        lib.getData('milesNBonusData')
      this.mbDictionary = dictionary
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.milesNBonusLogo = milesNBonusLogo
      this.id = milesNBonusAccount.id
      this.destinationAllowed = configuration.destinationAllowed
      this.redeemAllowed = configuration.redeemAllowed

      this.setEventListeners()
      this.$nextTick(() => {
        this.mbRibbon = new MBRibbon(
          this.$refs.milesNBonusRibbon,
          this.$refs.milesNBonusRibbonMockBackground
        )
      })
    }
  },

  methods: {
    showModal() {
      document.dispatchEvent(new CustomEvent('showMilesNBonusModal', {}))
    },

    setEventListeners() {
      document.addEventListener('milesNBonusLogStatus', (e) => {
        this.milesNBonusLoggedIn = e.detail.logStatus
        this.miles = e.detail.miles
        this.redeemAllowed = e.detail.redeemAllowed
      })
    },
  },
}
</script>
